import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { PostServiceCallCreate } from 'src/app/models/quote/post-service-call-create';
import { PostServiceCallQuoteItemCreate } from 'src/app/models/quote/post-service-call-quote-item-create';
import { QuoteAssemblyAddedEvent } from 'src/app/models/quote/quote-assembly-added-event';
import { QuoteServiceCallNavigationState } from 'src/app/models/quote/quote-service-call-navigation-state';
import { ResponseCreateServiceCall } from 'src/app/models/quote/response-create-service-call';
import { PostRecommendationItemCreate } from 'src/app/models/recommendation/post-recommendation-item-create';
import { RecommendationAssemblyAddedEvent } from 'src/app/models/recommendation/recommendation-assembly-added-event';
import { ReturnMessage } from 'src/app/models/return-message';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  private loginSubject = new Subject<any>();
  private logoutSubject = new Subject<any>();

  private recommendationItemAdded = new Subject<PostRecommendationItemCreate>();
  private recommendationAssemblyAdded = new Subject<RecommendationAssemblyAddedEvent>();

  private quoteItemAdded = new Subject<PostServiceCallQuoteItemCreate>();
  private quoteAssemblyAdded = new Subject<QuoteAssemblyAddedEvent>();

  private serviceCallCreated = new Subject<{ quoteId: number; addressId: string}>();

  constructor() { }

  publishLogin(data: any) {
    this.loginSubject.next(data);
  }

  publishLogout() {
    this.logoutSubject.next();
  }

  getLoginSubject() {
    return this.loginSubject;
  }

  getLogoutSubject() {
    return this.logoutSubject;
  }

  getRecommendationItemAddedSubject() {
    return this.recommendationItemAdded;
  }

  getRecommendationAssemblyAddedSubject() {
    return this.recommendationAssemblyAdded;
  }

  getQuoteItemAddedSubject() {
    return this.quoteItemAdded;
  }

  getQuoteAssemblyAddedSubject() {
    return this.quoteAssemblyAdded;
  }

  getServiceCallCreatedSubject() {
    return this.serviceCallCreated;
  }

}
